<template>
  <label class="flex items-center justify-between gap-4 cursor-pointer group">
    <div class="flex flex-col">
      <span class="text-sm font-bold text-[#1c4848]" :class="titleClass">{{ title }}</span>
      <span v-if="description" class="text-[10px] text-[#1c4848]/50 font-medium" :class="descClass">{{ description }}</span>
    </div>
    <div class="relative shrink-0 w-11 h-6">
      <input
        :checked="modelValue"
        type="checkbox"
        class="sr-only peer"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <div
        class="w-11 h-6 rounded-full transition-all"
        :class="[modelValue ? 'bg-[#1c4848]' : 'bg-[#1c4848]/10', trackClass]"
      />
      <div
        class="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform shadow-sm pointer-events-none"
        :class="modelValue ? 'translate-x-5' : 'translate-x-0'"
      />
    </div>
  </label>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  titleClass: { type: String, default: '' },
  descClass: { type: String, default: '' },
  trackClass: {
    type: String,
    default: 'bg-[#1c4848]/10 peer-checked:bg-[#1c4848]'
  }
});

defineEmits(['update:modelValue']);
</script>
